import {Component, DestroyRef, EventEmitter, inject, Output} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AuthorizationService } from '../../services/authorization.service';
import { NgIf } from '@angular/common';
import { Permissions } from '../../shared/permissions';
import { FormControl } from '@angular/forms';
import { StateService } from '../../services/state.service';
import {SelectItem, SelectMenuComponent, SelectMode} from '../../shared/components/select-menu/select-menu.component';
import { PosthogService } from '../../services/posthog.service';
import {DashboardService} from '../../services/dashboard.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-profile',
  imports: [NgIf, SelectMenuComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  public name: string = '';
  public email: string = '';
  public isAllowedManageAccounts: boolean = false;
  public isAllowedAccountDropdown: boolean = false;
  public accountOptions : SelectItem[] = [];
  public selectedAccount: FormControl = new FormControl('');
  private destroyRef = inject(DestroyRef);
  @Output() manageAccountsClicked = new EventEmitter<void>();

  constructor(
    private auth: AuthService,
    private authorizationService: AuthorizationService,
    private stateService: StateService,
    private postHogService: PosthogService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit(){
    const { firstName, lastName, email } = this.authorizationService.userProfile;
    this.email = email;
    this.name = `${firstName} ${lastName}`;
    this.isAllowedManageAccounts = this.authorizationService.hasPermissions([Permissions.LIST_USERS, Permissions.WRITE_USER,Permissions.WRITE_BRAND]);
    this.isAllowedAccountDropdown = this.authorizationService.hasPermissions([Permissions.READ_ACCOUNT]);
    this.accountOptions = this.stateService.accounts
      .map(acc => ({ label: acc.name, key: acc.key }))
      .sort((a, b) => a.label.localeCompare(b.label));
    this.selectedAccount.setValue(this.stateService.activeAccount());
  }

  logOut(): void{
    this.auth.logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
    this.postHogService.reset();
  }

  goToManageScreen(): void {
    this.manageAccountsClicked.emit();
  }

  selectAccount(){
    this.stateService.setActiveAccount(this.selectedAccount.value);
    this.dashboardService.refreshFilters().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  protected readonly SelectMode = SelectMode;
}
